const fireBaseConfig = {
    apiKey: "AIzaSyBO43V_e4mITMk5wRTz12dsakfcnq6U6k0",
    authDomain: "customproject-79185.firebaseapp.com",
    projectId: "customproject-79185",
    storageBucket: "customproject-79185.appspot.com",
    messagingSenderId: "140971812497",
    appId: "1:140971812497:web:f28d4519bda95a69ed0130",
    measurementId: "G-K4CBJNDV07"
  };

  export default fireBaseConfig;